import React, { useState } from 'react';
import { LeafIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
type Panel = 'terms' | 'privacy' | null;
export function Footer() {
  const [active, setActive] = useState<Panel>(null);
  const toggle = (panel: Exclude<Panel, null>) => setActive(prev => prev === panel ? null : panel);
  return <footer className="bg-[#0a221c] text-sand border-t border-cream/10" data-id="element-226">
      {/* Cyclable legal panel */}
      <AnimatePresence data-id="element-227">
        {active && <motion.div key={active} initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="overflow-hidden border-b border-cream/10" data-id="element-228">
            <div className="max-w-[800px] mx-auto px-5 py-8 text-sm leading-relaxed space-y-3" data-id="element-229">
              {active === 'privacy' ? <>
                  <h3 className="font-serif text-2xl text-cream mb-4" data-id="element-230">
                    Política de privacidad
                  </h3>
                  <p data-id="element-231">
                    <strong className="text-cream" data-id="element-232">
                      1. Recopilación de datos.
                    </strong>{' '}
                    Recopilamos únicamente la información necesaria para
                    procesar tu compra: nombre, correo electrónico y datos de
                    pago. No almacenamos datos de tarjetas en nuestros
                    servidores.
                  </p>
                  <p data-id="element-233">
                    <strong className="text-cream" data-id="element-234">
                      2. Uso de la información.
                    </strong>{' '}
                    Tu información se utiliza exclusivamente para enviarte el
                    producto adquirido, comunicaciones relacionadas con tu
                    compra y, si lo autorizas, novedades de Libre de Endodolor.
                  </p>
                  <p data-id="element-235">
                    <strong className="text-cream" data-id="element-236">
                      3. Protección de datos.
                    </strong>{' '}
                    Implementamos medidas de seguridad técnicas y organizativas
                    para proteger tu información contra acceso no autorizado.
                  </p>
                  <p data-id="element-237">
                    <strong className="text-cream" data-id="element-238">4. Cookies.</strong>{' '}
                    Utilizamos cookies para mejorar tu experiencia y analizar el
                    tráfico del sitio. Puedes desactivarlas desde la
                    configuración de tu navegador en cualquier momento.
                  </p>
                  <p data-id="element-239">
                    <strong className="text-cream" data-id="element-240">5. Tus derechos.</strong>{' '}
                    Puedes acceder, rectificar, oponerte o eliminar tus datos
                    personales en cualquier momento contactándonos a nuestro
                    correo de soporte.
                  </p>
                  <p data-id="element-241">
                    <strong className="text-cream" data-id="element-242">6. Contacto.</strong> Para
                    cualquier consulta sobre el tratamiento de tus datos,
                    escribe a soporte@libredeendodolor.com.
                  </p>
                </> : <>
                  <h3 className="font-serif text-2xl text-cream mb-4" data-id="element-243">
                    Términos y condiciones
                  </h3>
                  <p data-id="element-244">
                    <strong className="text-cream" data-id="element-245">1. Producto digital.</strong>{' '}
                    "Libre de Endodolor" es un producto digital informativo en
                    formato PDF. Al completar la compra recibirás acceso
                    inmediato al contenido descargable.
                  </p>
                  <p data-id="element-246">
                    <strong className="text-cream" data-id="element-247">2. Uso personal.</strong> El
                    contenido es para uso personal e intransferible. Queda
                    prohibida su reproducción, distribución o reventa sin
                    autorización expresa.
                  </p>
                  <p data-id="element-248">
                    <strong className="text-cream" data-id="element-249">
                      3. Garantía de devolución.
                    </strong>{' '}
                    Ofrecemos una garantía de satisfacción de 30 días. Si no
                    estás conforme, puedes solicitar un reembolso completo
                    dentro de ese plazo sin necesidad de justificación.
                  </p>
                  <p data-id="element-250">
                    <strong className="text-cream" data-id="element-251">
                      4. Descargo de responsabilidad médica.
                    </strong>{' '}
                    Este producto tiene fines informativos y educativos. No
                    sustituye el diagnóstico, tratamiento ni consejo de un
                    profesional médico. Consulta siempre con tu médico antes de
                    realizar cambios en tu alimentación o estilo de vida.
                  </p>
                  <p data-id="element-252">
                    <strong className="text-cream" data-id="element-253">5. Resultados.</strong> Los
                    resultados pueden variar de una persona a otra y dependen de
                    factores individuales. No garantizamos resultados
                    específicos.
                  </p>
                  <p data-id="element-254">
                    <strong className="text-cream" data-id="element-255">6. Modificaciones.</strong>{' '}
                    Nos reservamos el derecho de actualizar estos términos en
                    cualquier momento; las modificaciones serán efectivas desde
                    su publicación en este sitio. © 2026 Libre de Endodolor.
                  </p>
                </>}
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* Footer bar */}
      <div className="max-w-[1200px] mx-auto px-5 py-6 md:py-7 flex flex-col md:flex-row items-center justify-between gap-4 md:gap-5 text-center md:text-left" data-id="element-256">
        <div className="flex items-center gap-2.5" data-id="element-257">
          <LeafIcon className="w-5 h-5 text-peach" data-id="element-258" />
          <span className="font-serif text-lg md:text-xl text-cream" data-id="element-259">
            Libre de Endodolor
          </span>
        </div>

        <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm" data-id="element-260">
          <button onClick={() => toggle('terms')} className={`transition-colors hover:text-cream ${active === 'terms' ? 'text-cream' : 'text-sand'}`} aria-expanded={active === 'terms'} data-id="element-261">
            Términos y condiciones
          </button>
          <span className="w-1 h-1 rounded-full bg-sand/40" aria-hidden="true" data-id="element-262" />
          <button onClick={() => toggle('privacy')} className={`transition-colors hover:text-cream ${active === 'privacy' ? 'text-cream' : 'text-sand'}`} aria-expanded={active === 'privacy'} data-id="element-263">
            Política de privacidad
          </button>
        </nav>

        <p className="text-xs text-sand/70" data-id="element-264">
          © 2026 Libre de Endodolor · Información educativa, no sustituye
          consejo médico.
        </p>
      </div>
    </footer>;
}